import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStrikethroughBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconStrikethroughBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M27.707 5.707a1 1 0 0 0-1.414-1.414l-2.261 2.26A4 4 0 0 0 22 6H10a4 4 0 0 0-4 4v12c0 .742.202 1.436.554 2.032l-2.261 2.26a1 1 0 1 0 1.414 1.415l2.261-2.26A4 4 0 0 0 10 26h12a4 4 0 0 0 4-4V10c0-.742-.202-1.436-.554-2.032zm-5.189 2.36A2 2 0 0 0 22 8H10a2 2 0 0 0-2 2v12q.001.27.068.518zM9.482 23.933l14.45-14.45Q24 9.73 24 10v12a2 2 0 0 1-2 2H10q-.27-.001-.518-.068"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStrikethroughBox32);
